import { Button } from "@mui/material";
import { useTranslations } from "use-intl";

import { RequiredLabel } from "@/app/ui/additional-services/RequiredLabel";
import { IconLuggage } from "@/components/Icons";

type Props = {
  required?: boolean;
  selectedAmount?: number;
};

export const AddBaggageCard = ({ required, selectedAmount }: Props) => {
  const t = useTranslations();

  return (
    <div className="relative flex flex-col rounded-3xl bg-white p-1">
      <div className="flex items-center gap-1 p-3">
        <IconLuggage className="size-18 shrink-0" />
        <div>
          <div className="font-medium text-text-primary">
            {t("travellers.addExtraBaggage")}
          </div>
          <div className="text-sm text-text-tertiary">
            {t("travellers.carryMore")}
          </div>
          {selectedAmount && selectedAmount > 0 ? (
            <div className="mt-1 text-sm font-medium text-core-accent-500">
              {t("travellers.xExtraBaggagesSelected", {
                amount: selectedAmount,
              })}
            </div>
          ) : null}
        </div>
      </div>
      <div className="p-3 pt-1">
        {/* TODO: onClick will redirect user to baggage list */}
        <Button variant="outlined" fullWidth onClick={() => {}}>
          {t("travellers.addBaggage")}
        </Button>
      </div>
      {required ? <RequiredLabel /> : null}
    </div>
  );
};
